import SyncableModel from "./SyncableModel"

export default class Country extends SyncableModel {
    static name = 'Country'

    incrementing = false

    _keyType = 'string'

    timestamps = false

    static syncOnly = true

    static hasSyncedAt = false

    static endpoint = '/countries'

    static searchables = ['name']
}
